<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3.61212 15.443C3.22612 15.641 2.78812 15.294 2.86612 14.851L3.69612 10.121L0.173118 6.765C-0.155882 6.451 0.0151183 5.877 0.456118 5.815L5.35412 5.119L7.53812 0.792004C7.73512 0.402004 8.26812 0.402004 8.46512 0.792004L10.6491 5.119L15.5471 5.815C15.9881 5.877 16.1591 6.451 15.8291 6.765L12.3071 10.121L13.1371 14.851C13.2151 15.294 12.7771 15.641 12.3911 15.443L8.00012 13.187L3.61112 15.443H3.61212Z"
      fill="#E33065"
    />
  </svg>
</template>
<script>
export default {};
</script>
<style></style>
